export class MensajeUsuarioOpcionEnvio {
  constructor(
    public readonly Id: number,
    public readonly Nombre: string | null,
    public readonly Codigo: string | null,
    public  Activo: boolean
  ) {}
}

export class SearchMensajeUsuarioOpcionEnvioRequest {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,
    public readonly Nombre: string | null,
    public readonly Codigo: string | null,
    public readonly RolId: number | null,
    public readonly VerSoloParaRecepcion: boolean | null,
    public readonly VerSoloActivos: boolean | null
  ) {}
}

export class SaveMensajeUsuarioOpcionEnvioDto {
  constructor(
    public readonly Codigo: string | null,
    public Nombre: string | null,
    public Activo: boolean
  ) {}
}

export class SearchMensajeUsuarioOpcionEnvioResponse {
  constructor(
    public readonly count: number,
    public readonly result: MensajeUsuarioOpcionEnvio[]
  ) {}
}
